import React, { memo } from "react";
import {
	BeneficialOwnerResource,
	BeneficialOwner
} from "@ploy-lib/rest-resources";
import { ExpandableListEditSingle, ConfigElement } from "@ploy-ui/core";
import { FormHelperText, Grid, ListItemText } from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";

import { ErrorMessage } from "formik";

const collapsedElement = (values: BeneficialOwner) => (
	<Grid container alignItems="center">
		<ChevronRight />
		<ListItemText
			primary={`${values.firstname} ${values.lastname}`}
			secondary={values.share}
		/>
	</Grid>
);

export interface UpdateBeneficialOwnerFieldProps {
	fieldName: string;
	beneficialOwners: BeneficialOwner[];
	beneficialOwnerConfig: ConfigElement<BeneficialOwner>[];
	onCreateBeneficialOwner: (beneficialOwner: BeneficialOwner) => any;
	onUpdateBeneficialOwner: (beneficialOwner: BeneficialOwner) => any;
	onDeleteBeneficialOwner: (beneficialOwner: BeneficialOwner) => any;
	getPersonalInfoFromSsn: (
		beneficialOwner: BeneficialOwner
	) => Promise<BeneficialOwner>;
}
/**
 * @param fieldName FieldNAme
 * @param beneficialOwners list of beneficialOwners
 * @param beneficialOwnerConfig config for expandableListEditSingle
 * @param onCreateBeneficialOwner function for creating beneficialOwner
 * @param onUpdateBeneficialOwner function for updating existing beneficialOwner
 * @param onDeleteBeneficialOwner function for deleting existing beneficialOwner
 * @param getPersonalInfoFromSsn function for getting personal info form ssn.
 */
const UpdateBeneficialOwnerFieldView = memo(
	(props: UpdateBeneficialOwnerFieldProps) => {
		const {
			fieldName,
			beneficialOwners,
			beneficialOwnerConfig,
			onCreateBeneficialOwner,
			onUpdateBeneficialOwner,
			onDeleteBeneficialOwner,
			getPersonalInfoFromSsn
		} = props;

		return (
			<Grid xs={12}>
				<ExpandableListEditSingle<BeneficialOwner>
					initialElementsList={beneficialOwners}
					elementIdKey={"id"}
					elementConfig={beneficialOwnerConfig}
					onCreate={onCreateBeneficialOwner}
					onUpdate={onUpdateBeneficialOwner}
					onDelete={onDeleteBeneficialOwner}
					elementCreator={() => BeneficialOwnerResource.fromJS({})}
					collapsedElement={collapsedElement}
					margin="dense"
					useThemedButtons
					canDelete
					autofillFunction={getPersonalInfoFromSsn}
					columns={2}
				/>

				<ErrorMessage
					name={fieldName}
					render={errorMessage => (
						<FormHelperText error>{errorMessage}</FormHelperText>
					)}
				/>
			</Grid>
		);
	}
);

UpdateBeneficialOwnerFieldView.displayName = "UpdateBeneficialOwnerFieldView";

export { UpdateBeneficialOwnerFieldView };
